import React from "react";
import { Controller } from "react-hook-form";
import { Col, Label } from "reactstrap";
import { Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AntSelect } from "../../CommonElements/AntSelect";

export const GenderField = ({
  control,
  errors,
  colSize = "md-4",
  required = true,
  name = "gender",
  labelKey = "GENDER"
}) => {
  const { t } = useTranslation();

  return (
    <Col {...{ [colSize.split('-')[0]]: colSize.split('-')[1] }}>
      <Stack gap={1} className="mb-3">
        <Label className={`fw-bold ${required ? 'required' : ''}`} for={name}>
          {t(labelKey)}
        </Label>
        <Controller
          name={name}
          control={control}
          rules={{
            ...(required && { required: t("FIELD_REQUIRED") })
          }}
          render={({ field }) => (
            <AntSelect
              id={name}
              name={name}
              placeholder={t("MALE_FEMALE")}
              {...field}
              status={errors[name] ? "error" : undefined}
              options={[
                { value: "male", label: t("MALE") },
                { value: "female", label: t("FEMALE") },
              ]}
            />
          )}
        />
        {errors[name] && (
          <div className="text-danger mt-1">{errors[name].message}</div>
        )}
      </Stack>
    </Col>
  );
};
